







































import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import useRenovacaoAutorizacao from '@/composables/useRenovacaoAutorizacao/useRenovacaoAutorizacao'
import { AgendamentoSolicitacaoItem } from '@/types/_'

@Component
export default class ModalBackofficeRenovarAutorizacao extends Vue {
  @Prop() visible: boolean
  @Prop() agendamento: AgendamentoSolicitacaoItem | null

  show: boolean = false

  @Watch('visible')
  onVisibilityChange(visible: boolean) {
    this.show = visible
  }

  @Emit('close')
  close() {}

  @Emit('renovado')
  renovado() {}

  get loadingConfirmar() {
    return useRenovacaoAutorizacao.loadingConfirmar
  }

  async confirmar() {
    if (!this.agendamento) return

    const sucesso = await useRenovacaoAutorizacao.confirmarRenovacao(this.agendamento.id)

    if (sucesso) {
      this.renovado()
      this.close()
    }
  }
}
